import { UserGroupIcon } from "@heroicons/react/24/outline"
import { Navigate, Route, Routes } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import { EndUsersList } from "./EndUsers"

const _routes: RouteElement[] = [
    {
        route: 'ott-users',
        title: 'OTT Users',
        component: EndUsersList,
        icon: UserGroupIcon,
        display: true
    }
]

const EndUserManagement = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes}/>
            <div className="p-3">
                <Routes>
                    <Route path='' element={<Navigate to={_routes[0].route} replace/>}>
                    </Route>
                    {_routes.map(route => (
                        <Route path={route.route} key={'ottUsers' + route.route} element={<route.component />} />
                    ))}
                </Routes>
            </div>
        </div>
    )
}

export default EndUserManagement

